import { gql } from '@apollo/client';

const TASK_TOGGLE_PHOTO_REQUIRED = gql`
  mutation TaskTogglePhotoRequired($input: TaskTogglePhotoRequiredInput!) {
    taskTogglePhotoRequired(input: $input) {
      errors {
        error
        message
      }
      task {
        id
        photoCaptureRequired
        __typename
      }
    }
  }
`;

export default TASK_TOGGLE_PHOTO_REQUIRED;
